import { z } from "zod";
import { RAID_ROLES } from "@/shared/lib/roles";
import { WOW_CLASSES } from "@/shared/lib/wowClass";

export const standInSchema = z.object({
  name: z.string().trim().min(1, "Ange ett namn.").max(50, "Högst 50 tecken."),
  // Class/role are optional — a stand-in can be added by name and filled in later.
  wowClass: z.enum(WOW_CLASSES).nullable(),
  raidRole: z.enum(RAID_ROLES).nullable(),
});

export type StandInFormInput = z.input<typeof standInSchema>;
export type StandInFormValues = z.output<typeof standInSchema>;
